import {getFetchedJSON, throwOnError} from '~/misc/fetch';

const host = 'https://tranquil-refuge-59242.herokuapp.com';

export const loadLocations = (area) =>
  window.fetch(`${host }/poi/locations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify({
      geometry: area.geometry,
    }),
  })
    .then(throwOnError)
    .then(getFetchedJSON);


export const loadWeightStation = (ids) =>
  window.fetch(`${host}/poi/weight-stations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify({
      ids: ids,
    }),
  })
    .then(throwOnError)
    .then(getFetchedJSON);

export const loadBusiness = (ids, filter) =>
  window.fetch(`${host}/poi/business`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
    body: JSON.stringify({
      ids: ids,
      fields: [filter],
      has: [filter],
    }),
  })
    .then(throwOnError)
    .then(getFetchedJSON);



// WEBPACK FOOTER //
// ./src/modules/loads/api.js